export default __webpack_public_path__ + "static/2-f33c75e2b56f59bddd7e129c9e0b2b4b.png";